import icon from 'vue-svgicon';

icon.register({
    'bold/microphone': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12 16a4.505 4.505 0 0 0 4.5-4.5v-7a4.5 4.5 0 0 0-9 0v7A4.505 4.505 0 0 0 12 16z"/><path pid="1" d="M19 8a1 1 0 0 0-1 1v2.5a6 6 0 0 1-12 0V9a1 1 0 0 0-2 0v2.5a8.013 8.013 0 0 0 6.788 7.908.25.25 0 0 1 .212.247V23a1 1 0 0 0 2 0v-3.345a.25.25 0 0 1 .212-.247A8.013 8.013 0 0 0 20 11.5V9a1 1 0 0 0-1-1z"/>`,
    },
});
